import jsCookie from 'js-cookie'
import React, { useRef } from 'react'

export type LogoutMessageProps = {
  message?: string
}

export const LogoutMessage: React.FC<LogoutMessageProps> = ({ message }) => {
  const logoutMessageRef = useRef<HTMLDivElement>(null)
  const lastAmpAuthState = jsCookie.get('lastAmpAuthState')
  const loggedIn = jsCookie.get('amp-wls')

  if (!(lastAmpAuthState === 'active' && loggedIn === 'false')) {
    return null
  }

  if (message === undefined) {
    return null
  }

  // TODO use Notification component
  return (
    <div className="u-paddingHoriz8 u-paddingTop8">
      <div role="alert">
        <div className="Notification Notification--withIcon Notification--alert Notification--confirm">
          <div
            ref={logoutMessageRef}
            className="Notification-content js-formNotification"
            dangerouslySetInnerHTML={{ __html: message }}
          ></div>
        </div>
      </div>
    </div>
  )
}
